import { configureStore } from '@reduxjs/toolkit';

import rootReducer from 'store/reducers/index';

const store = configureStore({
  devTools: true, // TODO: disable in prod using next config
  reducer: rootReducer,
});

export type StoreState = ReturnType<typeof store.getState>;
export type StoreDispatch = typeof store.dispatch;

export default store;
